import { Icon } from '../icon';
import { Message } from '../../components/utils/Message';
import { MessageKey } from 'lightning-messages/lib/messages';
import './Checkbox.scss';

export interface CheckboxSlots {
    input?: {
        classes?: string;
    };
}

export interface CheckboxProps {
    labelKey: MessageKey;
    name?: string;
    onChange?: (value: boolean) => void;
    slots?: CheckboxSlots;
    subheadingKey?: MessageKey;
    value?: boolean;
    tabIndex?: number;
}

export const Checkbox = ({
    labelKey,
    name,
    onChange,
    slots,
    subheadingKey,
    value,
    tabIndex,
    ...rest
}: CheckboxProps) => (
    <label className="custom-checkbox">
        <input
            className={slots?.input?.classes}
            checked={value}
            data-testid="checkbox-input"
            name={name}
            onChange={(event) => onChange?.(event.currentTarget.checked)}
            type="checkbox"
            tabIndex={tabIndex}
            {...rest}
        />

        <Icon name="checked" aria-hidden="true" />
        <Icon name="unchecked" aria-hidden="true" />

        <Message
            className="checkbox-label"
            elementType="span"
            messageKey={labelKey}
        />

        {subheadingKey && (
            <Message
                className="checkbox-subheading"
                elementType="span"
                messageKey={subheadingKey}
            />
        )}
        <span className="js-saved Saved-container" />
    </label>
);
